import type { DailyV2TimelineEvent } from '@/api/schema/daily'
import { UI } from '@/app/components/UI/UI'
import { TimelineItem } from '@/app/pages/DailyV2Page/Timeline/Item'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const Timeline: FunctionalComponent<{
  timeline: DailyV2TimelineEvent[]
}> = props => {
  return (
    <div class={styles.root}>
      <UI.Panel class={styles.panel}>
        {props.timeline.map(item => (
          <TimelineItem
            item={item}
          />
        ))}
      </UI.Panel>
    </div>
  )
}
